import React from 'react';

const FeaturesSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">IDS教習所グループが選ばれる理由</h2>
          <p className="text-xl sm:text-lg text-gray-600">なぜ多くの農業従事者がIDS教習所グループを選ぶのか</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col min-h-[400px]">
            <div className="w-24 h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-4xl font-bold text-[#76B947]">01</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2A6041] mb-4 min-h-[4rem] flex items-center justify-center">
              農業ドローン協議会<br />「認定教習所」
            </h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed flex-1">
              DJI農業ドローン運用に必要な民間資格を発行する農業ドローン協議会の正式認定教習所。業界標準の技能認定証を確実に取得できます。
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col min-h-[400px]">
            <div className="w-24 h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-4xl font-bold text-[#76B947]">02</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2A6041] mb-4 min-h-[4rem] flex items-center justify-center">
              対面で実機実践教習
            </h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed flex-1">
              DJI AGRASシリーズ実機を使用し、インストラクターが隣で直接指導。座学だけでなく実際の飛行・散布操作を確実に習得。
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col min-h-[400px]">
            <div className="w-24 h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-4xl font-bold text-[#76B947]">03</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2A6041] mb-4 min-h-[4rem] flex items-center justify-center">
              購入から運用まで<br />「一貫サポート」
            </h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed flex-1">
              機体販売・資格取得・アフターサポートまで全てIDSにお任せ。購入後の操作指導や点検・整備も地域密着でサポートします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
